import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import translations from './translations';
import './index.scss';

const config = {
  revision: 1, // increment when the cookie list changes materially
  manageScriptTags: true, // auto-block <script> tags with data-category attrs
  cookie: {
    name: 'cc_cookie',
    expiresAfterDays: 365,
    sameSite: 'Strict',
    useLocalStorage: false
  },
  guiOptions: {
    consentModal: {
      position: 'bottom right'
    }
  },
  // ─── Categories ───────────────────────────────────────────────────────────
  categories: {
    necessary: {
      enabled: true,
      readOnly: true // cannot be toggled off
    },

    analytics: {
      enabled: false,
      autoClear: {
        cookies: [
          { name: /^_pk_id/ },
          { name: /^_pk_ses/ },
          { name: /^_pk_ref/ }
        ]
      }
    },

    marketing: {
      enabled: false,
      autoClear: {
        cookies: [
          { name: '_fbp', domain: location.hostname },
          { name: '_fbc', domain: location.hostname }
        ]
      }
    }
  }
};

function updateConsent(app, cookie) {
  if (~cookie.categories.indexOf('analytics')) {
    app.config.globalProperties.$matomo?.setCookieConsentGiven();
  } else {
    app.config.globalProperties.$matomo?.forgetCookieConsentGiven();
  }
  if (window.fbq) {
    if (~cookie.categories.indexOf('marketing')) {
      console.log('granted');
      window.fbq('consent', 'grant');
      window.fbq('track', 'PageView');
    } else {
      window.fbq('consent', 'revoke');
    }
  }
}

function getLangFromURL() {
  const url = new URL(window.location);
  const lang = url.pathname.split('/')[1];
  return lang == 'fr' || lang == 'it' ? lang : 'de';
}

export default {
  install: async (app, { axiosClient }) => {
    config.onConsent = ({ cookie }) => {
      const accepted =
        cookie.categories.filter((c) => c !== 'necessary').join(',') || 'none';
      const action = accepted === 'none' ? 'consent_refused' : 'consent_given';

      app.config.globalProperties.$matomo?.trackEvent(
        'Cookie Consent', // category
        action, // action
        accepted, // name  — e.g. "analytics,marketing" or "none"
        cookie.revision // value — lets you filter by config version in Matomo)
      );

      updateConsent(app, cookie);
    };

    config.onChange = ({ cookie, changedCategories }) => {
      const accepted =
        cookie.categories.filter((c) => c !== 'necessary').join(',') || 'none';
      app.config.globalProperties.$matomo?.trackEvent(
        'Cookie Consent', // category
        'consent_changed', // action
        accepted, // name  — e.g. "analytics,marketing" or "none"
        cookie.revision // value — lets you filter by config version in Matomo)
      );

      updateConsent(app, cookie);
    };

    const currentLang = getLangFromURL();

    config.language = translations(axiosClient, currentLang);
    app.config.globalProperties.$CookieConsent = CookieConsent;
    axiosClient.$loadCookieConsentStrings(currentLang).then((resp) => {
      if (resp.show_consent_banner)
        app.config.globalProperties.$CookieConsent.run(config);
    });
  }
};
